module.exports = __webpack_public_path__ + "img/cordoba.ff533e76.jpg";